import ReactDOM from 'react-dom';
import { Follow } from 'src/shared/design-system/Icon';
import { TooltipColors, Tooltip as TooltipComponent } from 'src/shared/design-system/Tooltip';
import styled from 'styled-components';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { Spacing } from 'web-common/src/shared/styles';

const Tooltip = styled(TooltipComponent).attrs(() => ({
  tooltipColor: TooltipColors.RED,
}))`
  position: absolute;
  inset: 0;
`;

const TooltipContent = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.HALF};

  & svg {
    width: ${Spacing.SINGLE};
  }
`;

export type TooltipProps = {
  isOpen?: boolean;
};

/**
 * Separate first time viewed modal when button is not used.
 */
export const FollowHeaderTooltip = (props) => {
  const { isSmallScreen } = useScreenContext();

  const accountHeader = document.getElementById('account-header-link');
  const navbarToggle = document.getElementById('header-navbar-toggle');
  const anchor = isSmallScreen ? navbarToggle : accountHeader;

  const tooltip = (
    <Tooltip
      content={
        <TooltipContent>
          <Follow /> Followed Shefs are saved here
        </TooltipContent>
      }
      {...props}></Tooltip>
  );

  return anchor ? (
    <>
      {ReactDOM.createPortal(
        tooltip,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        anchor as HTMLElement
      )}
    </>
  ) : null;
};
